import { render, staticRenderFns } from "./ShowItem.vue?vue&type=template&id=6d5c09d8"
import script from "./ShowItem.vue?vue&type=script&lang=js"
export * from "./ShowItem.vue?vue&type=script&lang=js"
import style0 from "./ShowItem.vue?vue&type=style&index=0&id=6d5c09d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports